import React from "react"

const OrderStatusFiller = props => {
  return (
    <>
      <div
        id="orderstatus"
        className=" aem-GridColumn aem-GridColumn--default--12"
      >
        <div className="order-status container-fluid">
          <div className="row no-gutters">
            <div className="col-lg-12 order-status__form-wrapper">
              <div className="order-status__banner">
                <div className="order-status__header">
                  <div className="order-status__title">
                    {" "}
                    <p className="shimmer-loading__title shimmer"></p>
                  </div>
                  <div className="order-status__desc">
                    <p className="shimmer-loading__para shimmer"></p>
                    <p className="shimmer-loading__para shimmer"></p>
                  </div>
                </div>
              </div>
              <div className="order-status__form">
                <div className="order-status__form-content">
                  <div className="Input_inputFieldWrapper__nt6o0">
                    <div
                      className=" input-field "
                      id="kf-order-status-number-wrapper"
                    >
                      <div>
                        <div className="input-field__value">
                          <p className="shimmer-loading__input shimmer"></p>
                          <label aria-hidden="true">
                            {" "}
                            <p className="shimmer-loading__para shimmer"></p>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="order-status__help-text gbh-data-layer"
                    role="link"
                    tabIndex="0"
                  >
                    <p className="shimmer-loading__para shimmer"></p>
                  </div>

                  <div className="Input_inputFieldWrapper__nt6o0">
                    <div
                      className=" input-field "
                      id="kf-order-status-email-wrapper"
                    >
                      <div>
                        <div className="input-field__value">
                          <p className="shimmer-loading__input shimmer"></p>
                          <label aria-hidden="true">
                            {" "}
                            <p className="shimmer-loading__para shimmer"></p>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Button_buttonWrapper__9Vvy_ kf-react-button button large black flexible order-status__find-btn ">
                    <p className="shimmer-loading__button shimmer"></p>
                  </div>
                  <div className="Recaptcha_reCatichWrapper__pIvbo">
                    <div className="mt-20 mb-20 recaptcha-links">
                      <span>
                        <p className="shimmer-loading__para shimmer"></p>
                      </span>
                      <a
                        className="gpolicies gbh-data-layer"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://policies.google.com/privacy"
                      >
                        <p className="shimmer-loading__para shimmer"></p>
                      </a>
                      <span>
                        <p className="shimmer-loading__para shimmer"></p>
                      </span>
                      <a className="gpolicies gbh-data-layer">
                        <p className="shimmer-loading__para shimmer"></p>
                      </a>
                      <span>
                        <p className="shimmer-loading__para shimmer"></p>
                      </span>
                    </div>
                  </div>
                  <div className="order-status__support">
                    <div>
                      <p className="shimmer-loading__para shimmer"></p>
                    </div>
                    <a>
                      <p className="shimmer-loading__para shimmer"></p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderStatusFiller
